import React from 'react'
import { useState } from 'react'

export function Tabs({ tabs, defaultTab = 0, variant = 'underline', fullWidth = false }) {
    const [activeTab, setActiveTab] = useState(defaultTab)

    // Styles for different variants
    const tabStyles = {
        underline: {
            container: 'flex border-b border-gray-200',
            tab: (isActive) => `
        px-4 py-2 text-sm font-medium transition-colors duration-200
        ${
            isActive
                ? 'border-b-2 border-[#DC143C] text-[#DC143C]'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
        }
        ${fullWidth ? 'flex-1 text-center' : ''}
      `,
        },
        pills: {
            container: 'flex space-x-2',
            tab: (isActive) => `
        px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200
        ${
            isActive
                ? 'bg-white text-[#DC143C] border-2 border-[#DC143C]  '
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }
        ${fullWidth ? 'flex-1 text-center' : ''}
      `,
        },
        boxed: {
            container: 'flex',
            tab: (isActive) => `
        px-4 py-2 text-sm font-medium transition-colors duration-200
        ${
            isActive
                ? 'bg-white border-t border-l border-r border-gray-200 rounded-t-lg text-[#DC143C]'
                : 'bg-gray-50 text-gray-500 hover:text-gray-700 border border-transparent'
        }
        ${fullWidth ? 'flex-1 text-center' : ''}
      `,
        },
        buttons: {
            container: 'flex p-1 bg-gray-100 rounded-lg space-x-1',
            tab: (isActive) => `
        px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200
        ${isActive ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'}
        ${fullWidth ? 'flex-1 text-center' : ''}
      `,
        },
    }

    const handleOnClick = (index, handler) => {
        setActiveTab(index)

        if (handler) {
            handler()
        }
    }

    return (
        <div className="w-full">
            {/* Tab Headers */}

            <div className="w-auto overflow-x-auto whitespace-nowrap pb-3">
                <div className={tabStyles[variant].container}>
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => handleOnClick(index, tab.handler)}
                            className={tabStyles[variant].tab(activeTab === index) + ' focus:outline-none'} // Added focus:outline-none here
                            aria-selected={activeTab === index}
                            role="tab"
                        >
                            <div className="flex items-center justify-center space-x-2">
                                {tab.icon && <span>{tab.icon}</span>}
                                <span>{tab.label}</span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            {/* Tab Content */}
            <div className="py-2">
                {tabs.map((tab, index) => (
                    <div key={index} className={`${activeTab === index ? 'block' : 'hidden'}`} role="tabpanel">
                        {tab.children}
                    </div>
                ))}
            </div>
        </div>
    )
}
